import { DataBroker } from './DataBroker';


const PRAKIM = [
	{	"name": "ספר בראשית",
		"wide": true,
		"prakim":	[	{ key:1, name:"בראשית" },
						{ key:2, name:"נח" },
						{ key:3, name:"לך לך" },
						{ key:4, name:"וירא" },
						{ key:5, name:"חיי שרה" },
						{ key:6, name:"תולדות" },
						{ key:7, name:"ויצא" },
						{ key:8, name:"וישלח" },
						{ key:9, name:"וישב" },
						{ key:10, name:"מקץ" },
						{ key:11, name:"ויגש" },
						{ key:12, name:"ויחי" }
					]
	},
	{	"name": "ספר שמות",
		"wide": true,
		"prakim":	[	{ key:13, name:"שמות" },
						{ key:14, name:"וארא" },
						{ key:15, name:"בא" },
						{ key:16, name:"בשלח" },
						{ key:17, name:"יתרו" },
						{ key:18, name:"משפטים" },
						{ key:19, name:"תרומה" },
						{ key:20, name:"תצוה" },
						{ key:21, name:"כי תשא" },
						{ key:22, name:"ויקהל" },
						{ key:23, name:"פקודי" }
					]
	},
	{	"name": "ספר ויקרא",
		"wide": true,
		"prakim":	[	{ key:24, name:"ויקרא" },
						{ key:25, name:"צו" },
						{ key:26, name:"שמיני" },
						{ key:27, name:"תזריע" },
						{ key:28, name:"מצורע" },
						{ key:29, name:"אחרי מות" },
						{ key:30, name:"קדושים" },
						{ key:31, name:"אמור" },
						{ key:32, name:"בהר" },
						{ key:33, name:"בחוקותי" }
					]
	},
	{	"name": "ספר במדבר",
		"wide": true,
		"prakim":	[	{ key:34, name:"במדבר" },
						{ key:35, name:"נשא" },
						{ key:36, name:"בהעלותך" },
						{ key:37, name:"שלח" },
						{ key:38, name:"קורח" },
						{ key:39, name:"חוקת" },
						{ key:40, name:"בלק" },
						{ key:41, name:"פינחס" },
						{ key:42, name:"מטות" },
						{ key:43, name:"מסעי" }
					]
	},
	{	"name": "ספר דברים",
		"wide": true,
		"prakim":	[	{ key:44, name:"דברים" },
						{ key:45, name:"ואתחנן" },
						{ key:46, name:"עקב" },
						{ key:47, name:"ראה" },
						{ key:48, name:"שופטים" },
						{ key:49, name:"כי תצא" },
						{ key:50, name:"כי תבוא" },
						{ key:51, name:"ניצבים" },
						{ key:52, name:"וילך" },
						{ key:53, name:"האזינו" },
						{ key:54, name:"ברכה" }
					]
	},
];




function GetPerekIndex(perekId) {
	return perekId;	
};

function RenderShiur(jsonData) {
	let lastPerek = '';

	return	<div className='Chumash'>
				{ [0,1,2,3,4,5,6].map(aliyaIndex => <>
						<center><b>{jsonData.name} - {jsonData.aliyot[aliyaIndex].name}</b></center>
						{ jsonData.aliyot[aliyaIndex].psukim.map(p => {
							
							let perek = '';
							if (lastPerek !== p.perek) {
								perek = <>{p.perek}, </>;
								lastPerek = p.perek;
							}

							return	<p>
										<small className="pasuk-number">{perek}{p.pasuk}</small>&nbsp;<big>{p.text}</big><br/>
										{ p.rashi.map(r => <><span dangerouslySetInnerHTML={{ __html: r.text.replaceAll("(", "<small class=\"quotation\">(").replaceAll(")", ")</small>") }} /> </>) }
									</p>
						}) }
					</>)
				}
			</div>;
};


export function GetPerekHeaderCM(perekId) {
	const sefer = PRAKIM.find(m => m.prakim.find(p => p.key == perekId));
	const perek = PRAKIM.map(p => p.prakim).flat().find(p => p.key == perekId);
	return (sefer.title && (perek.hidePerek===undefined||perek.hidePerek) ? sefer.title+" " : "") + perek.name;
};

export function GetPerekNextCM(perekId) {
	if (perekId == 54)
		return 1;

	return ++perekId;
};
export function GetPerekPrevCM(perekId) {
	if (perekId == 1) 
		return 54;

	return --perekId;
};



export async function GetPerekCM(perekId) {
	const arrIndex = GetPerekIndex(perekId);

	let data = await DataBroker.getDataJson('cm/' + arrIndex);

	return new Promise((myResolve, myReject) => {
		if (data === null)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(data));
	});
};

export function GetMenuCM() {
	return PRAKIM;
}